/**
 * UserPreferences API Client
 * Story 107-10: UserPreferences DB migration (Sally Tier 1 UX finding)
 *
 * Endpoint: GET/PUT/DELETE /api/v1/me/preferences/:category
 */

import { api } from './client';

export type PreferenceCategory = 'dashboard-widgets' | 'ui-theme' | 'notification-settings';

export interface PreferenceEntry {
  key: string;
  value: unknown;
  updatedAt: string;
}

export interface PreferencesResponse {
  data: PreferenceEntry[];
}

export interface SetPreferenceResponse {
  data: PreferenceEntry;
}

export interface BulkSetResponse {
  data: PreferenceEntry[];
  count: number;
}

export interface DeleteResponse {
  count: number;
}

/**
 * GET /api/v1/me/preferences/:category
 * Opcionálisan ?key=X egy specifikus entry lekéréséhez.
 */
export async function getPreferences(
  category: PreferenceCategory,
  key?: string
): Promise<PreferencesResponse> {
  const query = key ? `?key=${encodeURIComponent(key)}` : '';
  return api.get<PreferencesResponse>(`/me/preferences/${category}${query}`);
}

/**
 * PUT /api/v1/me/preferences/:category
 * Egyetlen preference entry upsert.
 */
export async function setPreference(
  category: PreferenceCategory,
  key: string,
  value: unknown
): Promise<SetPreferenceResponse> {
  return api.put<SetPreferenceResponse>(`/me/preferences/${category}`, { key, value });
}

/**
 * PUT /api/v1/me/preferences/:category/bulk
 * Teljes category felülírása (localStorage → DB első login-kor).
 */
export async function bulkSetPreferences(
  category: PreferenceCategory,
  entries: Array<{ key: string; value: unknown }>
): Promise<BulkSetResponse> {
  return api.put<BulkSetResponse>(`/me/preferences/${category}/bulk`, { entries });
}

/**
 * DELETE /api/v1/me/preferences/:category
 * Opcionálisan ?key=X egy specifikus entry törlésére.
 */
export async function deletePreferences(
  category: PreferenceCategory,
  key?: string
): Promise<DeleteResponse> {
  const query = key ? `?key=${encodeURIComponent(key)}` : '';
  return api.delete<DeleteResponse>(`/me/preferences/${category}${query}`);
}
